import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from './Constants';

const Add_DressSize = () => {
  const [dressTypes, setDressTypes] = useState([]);
  const [newUser, setNewUser] = useState({
    USER_ID: '',
    USER_NAME: '',
    gender: '',
    type_id: '',
    dress_size: ''
  });
  const [error, setError] = useState(null);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value,
    });
  };

  useEffect(() => {
    const fetchDressTypes = async () => {
      if (!newUser.gender) {
        setDressTypes([]);
        return;
      }

      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}dress_types_by_gender`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ gender: newUser.gender }),
        });

        const data = await response.json();
        const activeTypes = (data.dressTypes || []).filter(type => type.status === 'A');
        setDressTypes(activeTypes);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, [newUser.gender]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newUser.dress_size || !newUser.gender || !newUser.type_id) {
      setFormError('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('dress_size', newUser.dress_size);
      formData.append('dress_type', newUser.type_id);
      formData.append('gender', newUser.gender);

      const response = await fetch(`${BASE_URL}add_dresssize`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (!result.status) {
        throw new Error(result.message || 'Failed to add dress size');
      }

      navigate('/manage_dresssize');
    } catch (err) {
      setFormError(err.message);
    }
  };

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const handleCancel = () => {
    navigate('/manage_dresssize');
  };

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container">
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Add New Dress Size</h2>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className='form-group'>
                          <label>Gender</label>
                          <select
                            name="gender"
                            value={newUser.gender}
                            onChange={handleInputChange}
                            className='form-control'
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label>Dress Type</label>
                          <select
                            name="type_id"
                            className="form-control"
                            value={newUser.type_id}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Type</option>
                            {dressTypes.map((type) => (
                              <option key={type.id} value={type.id}>{type.dress_type}</option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="dress_size">Dress Size</label>
                          <input
                            type="text"
                            id="dress_size"
                            name="dress_size"
                            className="form-control"
                            value={newUser.dress_size}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button type="submit" className="btn btn-primary">Submit</button>
                          <button type="button" className="btn btn-secondary" onClick={handleCancel}>Cancel</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Add_DressSize;
